import _ from 'lodash';
import moment from 'moment';
import { Router } from 'pouter';

import AccountAx                        from 'app/actions/account';
import PageCadminBracketsAx             from 'app/actions/company-admin/page-brackets';
import PageCadminBracketsDashboardAx    from 'app/actions/company-admin/page-brackets-dashboard';
import PageCadminBracketsEditAx         from 'app/actions/company-admin/page-brackets-edit';
import PageCadminBracketsNewAx          from 'app/actions/company-admin/page-brackets-new';
import PageCadminCampaignsAx            from 'app/actions/company-admin/page-campaigns';
import PageCadminEditCampaignAx         from 'app/actions/company-admin/page-campaigns-edit';
import PageCadminNewCampaignAx          from 'app/actions/company-admin/page-campaigns-new';
import PageCadminDashboardEditAx        from 'app/actions/company-admin/page-dashboard-edit';
import PageCadminDashboardViewAx        from 'app/actions/company-admin/page-dashboard-view';
import PageCadminEmployeesAx            from 'app/actions/company-admin/page-employees';
import PageCadminGiftsAx                from 'app/actions/company-admin/page-gifts';
import PageCadminGrantsAx               from 'app/actions/company-admin/page-grants';
import PageCadminGroupsAx               from 'app/actions/company-admin/page-groups';
import PageCadminGroupsEditAx           from 'app/actions/company-admin/page-groups-edit';
import PageCadminGroupsNewAx            from 'app/actions/company-admin/page-groups-new';
import PageCadminMatchInquiriesAx       from 'app/actions/company-admin/page-match-inquiries';
import PageCadminMatchesAx              from 'app/actions/company-admin/page-matches';
import PageCadminOffDonsAx              from 'app/actions/company-admin/page-offline-donations';
import PageCadminPayrollAx              from 'app/actions/company-admin/page-payroll';
import PageCadminPurchaseAx             from 'app/actions/company-admin/page-purchase';
import PageCadminSettingsAx             from 'app/actions/company-admin/page-settings';
import PageCadminSlackSettingsAx        from 'app/actions/company-admin/page-slack-settings';
import PageCadminSsoAx                  from 'app/actions/company-admin/page-sso';
import PageCadminSubscriptionAx         from 'app/actions/company-admin/page-subscription';
import PageCadminTransactions2Ax        from 'app/actions/company-admin/page-transactions2';
import PageCadminVolAnalyticsAx         from 'app/actions/company-admin/page-vol-analytics';
import PageCadminVolDfdAx               from 'app/actions/company-admin/page-vol-dfd';
import PageCadminVolEventsAx            from 'app/actions/company-admin/page-vol-events';
import PageCadminEditVolEventAx         from 'app/actions/company-admin/page-vol-events-edit';
import PageCadminNewVolEventAx          from 'app/actions/company-admin/page-vol-events-new';
import PageCadminVolTrackingAx          from 'app/actions/company-admin/page-vol-tracking';
import PageCadminWalletAx               from 'app/actions/company-admin/page-wallet';
import NonprofitsAx                     from 'app/actions/nonprofits';
import PageBracketAx                    from 'app/actions/page-bracket';
import PageBracketBuilderAx             from 'app/actions/page-bracket-builder';
import PageBracketGameAx                from 'app/actions/page-bracket-game';
import PageCollectionAx                 from 'app/actions/page-collection';
import PageCampaignAx                   from 'app/actions/page-campaign';
import PageCompanyDashboardAx           from 'app/actions/page-company-dashboard';
import PageEvAx                         from 'app/actions/page-email-verification';
import PageEmployeeInviteAx             from 'app/actions/page-employee-invite';
import PageGiftsSendAx                  from 'app/actions/page-gifts-send';
import PageGroupAx                      from 'app/actions/page-group';
import PageGroupsAx                     from 'app/actions/page-groups';
import PageNonprofitsAx                 from 'app/actions/page-nonprofits';
import PageNonprofitDashboardAx         from 'app/actions/page-nonprofit-dashboard';
import PageNonprofitProfileAx           from 'app/actions/page-nonprofit-profile';
import PageNonprofitProfileEditAx       from 'app/actions/page-nonprofit-profile-edit';
import PageNonprofitProfilePreviewAx    from 'app/actions/page-nonprofit-profile-preview';
import PageUserProfileAx                from 'app/actions/page-user-profile';
import PageVolEventAx                   from 'app/actions/page-vol-event';
import PageVolunteerAx                  from 'app/actions/page-volunteer';
import PageVolunteerMeAx                from 'app/actions/page-volunteer-me';
import PageWalletAx                     from 'app/actions/page-wallet';
import SessionStorageAx                 from 'app/actions/session-storage';
import SlackConnectNoncesAx             from 'app/actions/slack-connect-nonces';
import millieApi                        from 'app/apis/millie';
import cadminApi                        from 'app/apis/company-admin';
import {
  Pages,
  Categories,
  EmployeeRoles,
  BackstageRoles,
  EmailVerificationReasons,
}                                       from 'app/constants';
import CadminCardsDuck                  from 'app/ducks/company-admin/cards';
import CadminChargeErrorsDuck           from 'app/ducks/company-admin/charge-errors';
import PageCadminAnalyticsDuck          from 'app/ducks/company-admin/page-analytics';
import PageCadminBudgetsDuck            from 'app/ducks/company-admin/page-budgets';
import PageCadminCampaignsTemplatesDuck from 'app/ducks/company-admin/page-campaigns-templates';
import PageCadminCampaignsViewDuck      from 'app/ducks/company-admin/page-campaigns-view';
import PageCadminCattrsDuck             from 'app/ducks/company-admin/page-cattrs';
import PageCadminDriveDonsDuck          from 'app/ducks/company-admin/page-drive-donations';
import PageCadminEmployeeDuck           from 'app/ducks/company-admin/page-employee';
import PageCadminEmployeesUploadDuck    from 'app/ducks/company-admin/page-employees-upload';
import PageCadminGiftsNewDuck           from 'app/ducks/company-admin/page-gifts-new';
import PageCadminGrantsNewDuck          from 'app/ducks/company-admin/page-grants-new';
import PageCadminGroupEmployeesDuck     from 'app/ducks/company-admin/page-group-employees';
import PageCadminGroupsSettingsDuck     from 'app/ducks/company-admin/page-groups-settings';
import PageCadminGroupsViewDuck         from 'app/ducks/company-admin/page-groups-view';
import PageCadminJunkDrawerDuck         from 'app/ducks/company-admin/page-junk-drawer';
import PageCadminNonprofitsDuck         from 'app/ducks/company-admin/page-nonprofits';
import PageCadminNteeCodesDuck          from 'app/ducks/company-admin/page-ntee-codes';
import PageCadminPageApprovalsDuck      from 'app/ducks/company-admin/page-settings-approvals';
import PageCadminStatsDuck              from 'app/ducks/company-admin/page-stats';
import PageCadminVolEventsDuck          from 'app/ducks/company-admin/page-vol-events-view';
import CreditCardsDuck                  from 'app/ducks/credit-cards';
import NteeCodesDuck                    from 'app/ducks/ntee-codes';
import OffDonsDuck                      from 'app/ducks/offline-donations';
import Page2faDuck                      from 'app/ducks/page-2fa';
import PageEveryCentDuck                from 'app/ducks/page-every-cent';
import PageSocialFeedDuck               from 'app/ducks/page-social-feed';
import PageHappeningsDuck               from 'app/ducks/page-happenings';
import PageIntlOrgsSearchDuck           from 'app/ducks/page-intl-orgs-search';
import PageOnboardingDuck               from 'app/ducks/page-onboarding';
import PageSetNewPwDuck                 from 'app/ducks/page-set-new-pw';
import SocialPostViewDuck               from 'app/ducks/social-post-view';
import categoryHelpers                  from 'app/helpers/categories';
import slackHelpers                     from 'app/helpers/slack';
import utils                            from 'app/helpers/utils';
import history                          from 'app/history';
import paths                            from 'app/paths';
import AuthSlx                          from 'app/selectors/auth';

const {majorNtees} = categoryHelpers;

const createRouter = (store) => {
  const handlerContext = { store };
  const router = new Router();
  router.setContext(handlerContext);

  /*
   *  handler wrappers
   */

  const requireUser = (handler, {useSignup=false} = {}) => (done, location, ...args) => {
    const currentUser = AuthSlx.currentUser(store.getState());
    if (!currentUser) {
      const loginPathFn = useSignup ? paths.signup : paths.login;
      return done({redirect: loginPathFn(location.url)});
    }
    if (!currentUser.emailVerified) {
      return done({redirect: paths.verifyEmailPage});
    }
    const cattrsMissing = !!currentUser.employment?.employee?.cattrsMissing;
    const isOnOnboarding = location.path === paths.onboarding();
    const isOnCadmin = location.path.startsWith('/cadmin/');
    if (!isOnOnboarding && !isOnCadmin && cattrsMissing) {
      return done({redirect: paths.onboarding(location.url)});
    }
    return handler(done, location, ...args);
  };

  // allows signed out, but if signed in will require that user have email verified and required cattrs
  const requireOnboarding = (handler) => (done, location, ...args) => {
    const currentUser = AuthSlx.currentUser(store.getState());
    if (currentUser) {
      if (!currentUser.emailVerified) {
        return done({redirect: paths.verifyEmailPage});
      }
      const cattrsMissing = !!currentUser.employment?.employee?.cattrsMissing;
      const isOnOnboarding = location.path === paths.onboarding();
      const isOnCadmin = location.path.startsWith('/cadmin/');
      if (!isOnOnboarding && !isOnCadmin && cattrsMissing) {
        return done({redirect: paths.onboarding(location.url)});
      }
    }
    return handler(done, location, ...args);
  };

  const requireCadmin = (handler, roles=[]) => requireUser((done, location, ...args) => {
    const { companySlug } = location.params;
    const throwAccessError = () => {
      const error = new Error('Company admin rights required');
      error.statusCode = 403;
      return done({error});
    };
    // handle wildcard slug
    if (companySlug === '~') {
      const currentUser = AuthSlx.currentUser(store.getState());
      if (!currentUser) return done({redirect: paths.login(location.url)});
      const company = currentUser.adminableCompany;
      if (company) {
        return done({redirect: location.url.replace('/~', `/${company.slug}`)});
      }
      return throwAccessError();
    }
    //
    const requiresApproval = AuthSlx.requiresApproval(store.getState());
    if (requiresApproval) return done({redirect: paths.approvalRequired()});
    const currentUser = AuthSlx.currentUser(store.getState());
    const isAdmin = currentUser.adminableCompany && (currentUser.adminableCompany.slug === companySlug);
    const hasPermission = isAdmin && [EmployeeRoles.ADMIN, ...roles].includes(currentUser.employment.employee.role);
    const canAccess = hasPermission || !!currentUser.backstageRole;
    if (!canAccess) {
      return throwAccessError();
    }
    return handler(done, location, ...args);
  });

  const requireEmployer = (handler) => requireUser((done, ...args) => {
    const currentUser = AuthSlx.currentUser(store.getState());
    if (currentUser && currentUser.employment) return handler(done, ...args);
    const error = new Error('Not Found');
    error.statusCode = 404;
    return done({error});
  });

  const requireBackstageAccess = (handler, roles) => (done, location, ...args) => {
    const currentUser = AuthSlx.currentUser(store.getState());
    if (!currentUser) return done({redirect: paths.login(location.url)});
    if (!roles.includes(currentUser.backstageRole)) {
      const error = new Error('Forbidden');
      error.statusCode = 403;
      return done({error});
    }
    return handler(done, location, ...args);
  };

  const simpleRedirect = (newPath) => (done) => {
    return done({redirect: newPath});
  };

  // use this handler to for the route to be handled by the server
  const requireServer = (done, location, ...args) => {
    window.location.href = `${location.path}${utils.buildQueryString(location.query)}`;
  };

  // will tack on a startDate and endDate if either is missing
  // TODO: allow default ranges other than last12Months
  const requireDateRange = (handler) => (done, location, ...args) => {
    const {params, query, path} = location;
    const frmt = 'YYYY-MM-DD';
    const newQuery = {};
    if (!moment(query.startDate, frmt).isValid()) newQuery.startDate = moment().subtract(1, 'year').add(1, 'day').format(frmt);
    if (!moment(query.endDate, frmt).isValid()) newQuery.endDate = moment().format(frmt);
    if (Object.keys(newQuery).length) {
      const redirect = `${path}${utils.buildQueryString({...query, ...newQuery})}`;
      return done({redirect});
    }
    return handler(done, location, ...args);
  };

  /*
   *  helpers
   */

  const checkPostLoginUrl = (location) => {
    if (__IS_SERVER__) return;
    const { postLoginUrl } = location.query;
    if (postLoginUrl) {
      store.dispatch(SessionStorageAx.setPostLoginUrl(postLoginUrl));
    }
  };

  const makeHandler = ({page, loadAx, requireCadmin: cadminRoles, ignorePrerendered=true, checkPostLoginUrl: checkPlu=false, ...opts}) => {
    let handler = (done, location, context, preRendered) => {
      if (checkPlu) checkPostLoginUrl(location);
      if (preRendered && ignorePrerendered) return;
      const fetchProm = store.dispatch(loadAx(location));
      const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
      waitProm
        .then(() => done({page}))
        .catch((error) => done({error}));
    };
    if (cadminRoles) {
      handler = requireCadmin(handler, cadminRoles);
    }
    if (opts.requireDateRange) {
      handler = requireDateRange(handler);
    }
    if (opts.requireEmployer) {
      handler = requireEmployer(handler);
    }
    if (opts.requireUser) {
      handler = requireUser(handler);
    }
    return handler;
  };

  const makeBsHandler = ({page, roles=[BackstageRoles.SUPER]}) => {
    roles.push(BackstageRoles.SUPER);
    return requireBackstageAccess((done, _location, _context, _preRendered) => {
      return done({page});
    }, roles);
  }

  /*
   *  Server Routes
   */

  router.use('/dtd/match', requireServer);

  /*
   *  Main Routes
   */

  router.use('/', (done, location, _context, preRendered) => {
    if (preRendered) return;
    const state = store.getState();
    // has default for employer?
    const defaultCompanyPath = AuthSlx.defaultCompanyPath(state);
    if (defaultCompanyPath) return done({redirect: defaultCompanyPath});
    // is nonprofit admin?
    const nonprofitAdmin = AuthSlx.nonprofitAdmin(state);
    if (nonprofitAdmin) return done({redirect: paths.nonprofitDashboard(nonprofitAdmin.nonprofit.id)});
    // is signed in?
    const currentUser = AuthSlx.currentUser(state);
    if (currentUser) return done({redirect: paths.nonprofits()});
    // otherwise
    return done({redirect: paths.login()});
  });

  router.use('/browser-not-supported', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    done({page: Pages.BROWSER_NOT_SUPPORTED});
  });

  router.use('/login', (done, location, _context, preRendered) => {
    checkPostLoginUrl(location);
    if (preRendered) return;
    const currentUser = AuthSlx.currentUser(store.getState());
    return currentUser
      ? currentUser.emailVerified
        ? done({redirect: '/'})
        : done({redirect: paths.verifyEmailPage})
      : done({page: Pages.LOGIN});
  });

  router.use('/2fa', (done, location, _context, preRendered) => {
    if (preRendered) return;
    store.dispatch(Page2faDuck.Ax.load(location)).then(() => {
      done({page: Pages['2FA']});
    }).catch((error) => {
      const is404 = error.response?.status === 404;
      if (is404) return done({redirect: '/'});
      done({error});
    });
  });

  router.use('/sso-login', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    return done({page: Pages.SSO_LOGIN});
  });

  router.use('/approval-required', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    return done({page: Pages.APPROVAL_REQUIRED});
  });

  router.use('/signup', (done, location, _context, preRendered) => {
    checkPostLoginUrl(location);
    if (preRendered) return;
    const currentUser = AuthSlx.currentUser(store.getState());
    return currentUser
      ? done({redirect: '/'})
      : done({page: Pages.SIGNUP});
  });

  router.use('/signup-employee', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    return done({ page: Pages.SIGNUP_EMP });
  });

  router.use('/signup-individual', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    return done({ page: Pages.SIGNUP_IND });
  });

  router.use('/forgot-password', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    const currentUser = AuthSlx.currentUser(store.getState());
    return currentUser
      ? done({redirect: '/'})
      : done({page: Pages.FORGOT_PASSWORD});
  });

  router.use('/resend-employee-invite', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    return done({ page: Pages.RESEND_EMP_INVITE });
  });

  router.use('/onboarding', makeHandler({
    page: Pages.ONBOARDING,
    loadAx: PageOnboardingDuck.Ax.load,
    requireEmployer: true,
    checkPostLoginUrl: true,
  }));

  router.use('/social/feed', makeHandler({
    page: Pages.FEED,
    loadAx: PageSocialFeedDuck.Ax.load,
    requireEmployer: true,
  }));

  router.use('/social/posts/:postId', makeHandler({
    page: Pages.SOCIAL_POST,
    loadAx: SocialPostViewDuck.Ax.loadPage,
    requireEmployer: true,
  }));

  router.use('/slack', (done, _location, _context, preRendered) => {
    return done({redirect: paths.productSlack()});
  });

  router.use('/slack/install', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    const currentUser = AuthSlx.currentUser(store.getState());
    const redirect = currentUser && currentUser.adminableCompany
      ? paths.cadminSlackSettings(currentUser.adminableCompany.slug)
      : paths.productSlack({wantsInstall: true});
    return done({redirect});
  });

  router.use('/slack/direct-install', requireUser((done, _location, _context, preRendered) => {
    if (preRendered) return;
    const currentUser = AuthSlx.currentUser(store.getState());
    if (!currentUser.adminableCompany) {
      const error = new Error('not a company admin');
      error.statusCode = 403;
      error.friendlyMessage = 'company admin access required';
      return done({error});
    }
    return done({redirect: slackHelpers.getOauthUrl({companyId: currentUser.adminableCompany.id})});
  }));

  router.use('/slack/connect-nonce/:id', requireUser((done, location, _context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(SlackConnectNoncesAx.loadConnectPage(location.params.id));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.SLACK_CONNECT_NONCE}))
      .catch((error) => done({error}));
  }));

  router.use('/style-guide', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    return done({ page: Pages.STYLE_GUIDE });
  });

  router.use('/verify-email', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    const needsEmailVerification = AuthSlx.needsEmailVerification(store.getState());
    return needsEmailVerification
      ? done({page: Pages.VERIFY_EMAIL})
      : done({redirect: '/'});
  });

  router.use('/verify-email/:id', (done, location, _context, preRendered) => {
    millieApi.emailVerificationsGet(location.params.id)
      .then(({emailVerification: ev}) => {
        if (ev.reason === EmailVerificationReasons.RESET_PW) {
          return done({redirect: paths.setNewPassword(ev.id)});
        }
        if (__IS_CLIENT__) {
          store.dispatch(PageEvAx.load(location));
        }
        return done({page: Pages.EMAIL_VERIFICATION});
      })
      .catch((error) => done({error}));
  });

  router.use('/new-password/:evId', makeHandler({
    page: Pages.SET_NEW_PW,
    loadAx: PageSetNewPwDuck.Ax.load,
  }));

  router.use('/nonprofits/ntee-codes', simpleRedirect('/nonprofits/ntee'));
  router.use('/nonprofits/ntee', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(NteeCodesDuck.Ax.loadAll());
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.NTEE_CODES}))
      .catch((error) => done({error}));
  });

  const nonprofitsHandler = requireOnboarding((done, location, context, preRendered) => {
    if (preRendered) return;
    const params = {};
    ['search', 'distance', 'sort', 'postalCode', 'badges', 'country', 'companyId', 'page', 'inFavorites', 'countryCode', 'cityId'].forEach((field) => {
      if (location.query[field]) params[field] = location.query[field];
    });
    const nteeProm = location.params.nteePath
      ? store.dispatch(NteeCodesDuck.Ax.get(location.params.nteePath.split('-')[0]))
      : Promise.resolve();
    let redirect;
    const fetchProm = nteeProm.then(({nteeCode}={}) => {
      const nonprofitsParams = {...params};
      if (nteeCode) {
        const correctPath = paths.nteeCode(nteeCode);
        const isAtCorrectPath = correctPath.split('?')[0] === location.path;
        if (!isAtCorrectPath) {
          redirect = paths.nteeCode(nteeCode, location.query);
          return;
        }
        nonprofitsParams.nteeCode = nteeCode.code;
      }
      return Promise.all([
        store.dispatch(PageNonprofitsAx.fetchNonprofits(nonprofitsParams)).catch(() => {}),
      ]);
    });
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => redirect ? done({redirect}) : done({page: Pages.NONPROFITS}))
      .catch((error) => done({error}));
  });

  router.use('/nonprofits',                (...args) => nonprofitsHandler(...args));
  router.use('/nonprofits/ntee/:nteePath', (...args) => nonprofitsHandler(...args));

  router.use(`/nonprofits/${Categories.ANIMALS}`,         simpleRedirect(paths.nteeCode(majorNtees.D)));
  router.use(`/nonprofits/${Categories.CIVIL_RIGHTS}`,    simpleRedirect(paths.nteeCode(majorNtees.R)));
  router.use(`/nonprofits/${Categories.COMMUNITY_DEV}`,   simpleRedirect(paths.nteeCode(majorNtees.S)));
  router.use(`/nonprofits/${Categories.CULTURE}`,         simpleRedirect(paths.nteeCode(majorNtees.A)));
  router.use(`/nonprofits/${Categories.EDUCATION}`,       simpleRedirect(paths.nteeCode(majorNtees.B)));
  router.use(`/nonprofits/${Categories.ENVIRONMENT}`,     simpleRedirect(paths.nteeCode(majorNtees.C)));
  router.use(`/nonprofits/${Categories.HEALTH}`,          simpleRedirect(paths.nteeCode(majorNtees.E)));
  router.use(`/nonprofits/${Categories.HUMAN_SERVICES}`,  simpleRedirect(paths.nteeCode(majorNtees.P)));
  router.use(`/nonprofits/${Categories.INTERNATIONAL}`,   simpleRedirect(paths.nteeCode(majorNtees.Q)));
  router.use(`/nonprofits/${Categories.OTHER}`,           simpleRedirect(paths.nteeCode(majorNtees.Z)));
  router.use(`/nonprofits/${Categories.PUBLIC_POLICY}`,   simpleRedirect(paths.nteeCode(majorNtees.W)));
  router.use(`/nonprofits/${Categories.RELIGION}`,        simpleRedirect(paths.nteeCode(majorNtees.X)));
  router.use(`/nonprofits/${Categories.PUBLIC_SERVICES}`, simpleRedirect(paths.nteeCode(majorNtees.M)));

  router.use('/nonprofits/:id/dashboard', requireUser((done, location, _context, preRendered) => {
    if (preRendered) return;
    const currentUser = AuthSlx.currentUser(store.getState());
    const nonprofitAdmin = currentUser.nonprofitAdmins.find((npa) => npa.nonprofit.id === location.params.id);
    if (!nonprofitAdmin) {
      const error = new Error();
      error.statusCode = 403;
      return done({error})
    }
    const fetchProm = store.dispatch(PageNonprofitDashboardAx.load(location.params.id));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.NONPROFIT_DASHBOARD}))
      .catch((error) => done({error}));
  }));

  const nonprofitHandler = requireOnboarding((done, location, _context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageNonprofitProfileAx.load(location.params.idOrEin)).then(({nonprofit}) => {
      const correctPath = paths.nonprofit(nonprofit, location.query);
      const isAtCorrectPath = correctPath.split('?')[0] === location.path;
      return {correctPath, isAtCorrectPath, nonprofit};
    });
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm.then(({correctPath, isAtCorrectPath} = {}) => {
      return (!isAtCorrectPath && __IS_SERVER__)
        ? done({ redirect: correctPath })
        : done({ page: Pages.NONPROFIT_PROFILE })
    }).catch((error) => done({error}));
    fetchProm.then(({correctPath, isAtCorrectPath} = {}) => {
      if (!isAtCorrectPath && !__IS_SERVER__) {
        process.nextTick(() => history.replace(correctPath));
      }
    }).catch(() => {});
  });
  router.use('/nonprofits/:idOrEin', nonprofitHandler);
  router.use('/nonprofits/:idOrEin/:name', nonprofitHandler);
  router.use('/nonprofits/:countryCode/:idOrEin/:name', nonprofitHandler);

  router.use('/global-organization-search', makeHandler({
    page: Pages.INTL_ORGS_SEARCH,
    loadAx: PageIntlOrgsSearchDuck.Ax.load,
  }));

  router.use('/credit-cards', requireUser((done, _location, _context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(CreditCardsDuck.Ax.fetchAll());
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({ page: Pages.CREDIT_CARDS }))
      .catch((error) => done({error}));
  }));

  router.use('/wallet', requireUser((done, location, _context, preRendered) => {
    const { nonprofitId } = location.query;
    if (__IS_CLIENT__) store.dispatch(SessionStorageAx.setDonationTargetById(nonprofitId));
    if (preRendered) return;
    const loadProm = store.dispatch(PageWalletAx.loadPage());
    const waitProm = __IS_SERVER__ ? loadProm : Promise.resolve();
    waitProm
      .then(() => done({ page: Pages.WALLET }))
      .catch((error) => done({error}));
  }));

  router.use('/offline-donations/new', makeHandler({
    page: Pages.OFFLINE_DONATIONS_NEW,
    loadAx: OffDonsDuck.Ax.loadPageNew,
    requireEmployer: true,
  }));
  router.use('/offline-donations/:id', makeHandler({
    page: Pages.OFFLINE_DONATIONS_SHOW,
    loadAx: OffDonsDuck.Ax.loadPageShow,
    requireEmployer: true,
  }));

  router.use('/claim', (done, location, _context, preRendered) => {
    if (preRendered) return;
    const currentUser = AuthSlx.currentUser(store.getState());
    if (currentUser && !currentUser.emailVerified) {
      return done({redirect: paths.verifyEmailPage});
    }
    const { nonprofitId } = location.query;
    const getProm = nonprofitId ? store.dispatch(NonprofitsAx.get(nonprofitId)) : Promise.resolve();
    const waitProm = __IS_SERVER__ ? getProm : Promise.resolve();
    waitProm
      .then(({nonprofit}={}) => {
        if (nonprofit && nonprofit.id !== nonprofitId) {
          return done({redirect: paths.claim(nonprofit.id)});
        }
        return done({page: Pages.CLAIM});
      })
      .catch((error) => {
        return _.get(error, 'response.status') < 500
          ? done({page: Pages.CLAIM})
          : done({error});
      });
  });

  router.use('/gift', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    const loadProm = store.dispatch(PageGiftsSendAx.load());
    const waitProm = __IS_SERVER__ ? loadProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.GIFTS_SEND}))
      .catch((error) => done({error}));
  });

  router.use('/redeem', requireUser((done, location, _context, preRendered) => {
    if (preRendered) return;
    return done({page: Pages.GIFTS_REDEEM});
  }, {useSignup: true}));

  router.use('/nonprofit-profiles/:id/edit', requireUser((done, location, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageNonprofitProfileEditAx.load(location.params.id));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({ page: Pages.NONPROFIT_PROFILE_EDIT }))
      .catch((error) => done({error}));
  }));

  router.use('/nonprofit-profiles/:id/preview', requireUser((done, location, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageNonprofitProfilePreviewAx.load(location.params.id));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({ page: Pages.NONPROFIT_PROFILE_PREVIEW }))
      .catch((error) => done({error}));
  }));

  router.use('/users/:id', (done, location, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageUserProfileAx.load(location.params.id));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.USER_PROFILE}))
      .catch((error) => done({error}));
  });

  router.use('/donatables/:id', (done, location, context, preRendered) => {
    millieApi.donatablesPath(location.params.id)
      .then(({path}) => done({redirect: path}))
      .catch((error) => done({error}));
  });

  router.use('/account', requireUser((done, location, context, preRendered) => {
    if (preRendered) return;
    done({page: Pages.ACCOUNT});
  }));

  router.use('/account/new-password', makeHandler({
    page: Pages.NEW_PASSWORD,
    loadAx: AccountAx.loadPageNewPw,
    requireUser: true,
  }));

  const ensureDatesEveryCent = (handler) => (done, location, ...args) => {
    const {from, to} = location.query;
    const needsDates = !from || !to;
    if (needsDates) {
      const fromMoment = moment.utc().subtract(1, 'month').startOf('month');
      const endMoment = fromMoment.clone().endOf('month');
      const newQuery = {
        ...location.query,
        from: fromMoment.format('YYYY-MM-DD'),
        to: endMoment.format('YYYY-MM-DD'),
      };
      return done({redirect: paths.everyCent(newQuery)});
    }
    return handler(done, location, ...args);
  };

  router.use('/every-cent', ensureDatesEveryCent(makeHandler({
    page: Pages.EVERY_CENT,
    loadAx: PageEveryCentDuck.Ax.loadPage,
    requireUser: true,
  })));

  router.use('/collections/:path', (done, location, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageCollectionAx.load(location.params.path));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.COLLECTION}))
      .catch((error) => done({error}));
  });

  router.use('/employees/invite/:token', (done, location, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageEmployeeInviteAx.load(location.params.token));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.EMPLOYEE_INVITE}))
      .catch((error) => done({error}));
  });

  router.use('/companies/:id', (done, location, context, preRendered) => {
    return millieApi.companiesGet(location.params.id).then(({company}) => {
      const redirect = company.companyDashboardId
        ? paths.companyDashboard(company.companyDashboardId)
        : paths.nonprofits({companyId: company.id});
      return done({redirect});
    }).catch((error) => done({error}));
  });

  router.use('/company-dashboards/:id', (done, {params, query}, context, preRendered) => {
    if (preRendered) return;
    const {startDate, endDate} = query;
    const fetchProm = store.dispatch(PageCompanyDashboardAx.load(params.id, {startDate, endDate}));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.COMPANY_DASHBOARD}))
      .catch((error) => done({error}));
  });

  router.use('/volunteer', requireOnboarding((done, {query}, context, preRendered) => {
    if (preRendered) return;
    const params = {};
    ['distance', 'sort', 'companyId', 'isRemote', 'isOngoing', 'cityId', 'nteeCode', 'tags', 'search', 'page'].forEach((field) => {
      if (query[field]) params[field] = query[field];
    });
    const fetchProm = store.dispatch(PageVolunteerAx.load(params));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.VOLUNTEER}))
      .catch((error) => done({error}));
  }));

  router.use('/volunteer/me', requireUser((done, {query}, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageVolunteerMeAx.load());
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.VOLUNTEER_ME}))
      .catch((error) => done({error}));
  }));

  router.use('/volunteer/:id', makeHandler({
    page: Pages.VOL_EVENT,
    loadAx: PageVolEventAx.load,
    requireEmployer: true,
  }));

  router.use('/events', makeHandler({
    page: Pages.HAPPENINGS,
    loadAx: PageHappeningsDuck.Ax.load,
    requireEmployer: true,
  }));

  router.use('/groups', requireEmployer((done, location, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageGroupsAx.load(location.params.id));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.GROUPS}))
      .catch((error) => done({error}));
  }));

  router.use('/groups/:id', makeHandler({
    page: Pages.GROUP,
    loadAx: PageGroupAx.load,
    requireEmployer: true,
  }));

  router.use('/brackets/:bracketId', requireEmployer((done, location, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageBracketAx.load(location.params.bracketId));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.BRACKET}))
      .catch((error) => done({error}));
  }));
  router.use('/bracket-games/:bracketGameId', requireEmployer((done, location, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageBracketGameAx.load(location.params.bracketGameId));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.BRACKET_GAME}))
      .catch((error) => done({error}));
  }));

  router.use('/campaigns/:campaignId', makeHandler({
    page: Pages.CAMPAIGN,
    loadAx: PageCampaignAx.load,
    requireEmployer: true,
  }));

  router.use('/bracket-builder', (done, location, context, preRendered) => {
    if (preRendered) return;
    // if signed in as comp admin then redirect to actual builder
    const company = AuthSlx.currentUser(store.getState())?.adminableCompany;
    if (company) {
      return done({redirect: paths.cadminBracketsNew(company.slug)});
    }
    //
    const fetchProm = store.dispatch(PageBracketBuilderAx.load(location));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.BRACKET_BUILDER}))
      .catch((error) => done({error}));
  });

  /*
   *  Company Admin
   */

  router.use('/cadmin/:companySlug/dashboard', requireCadmin((done, location, context, preRendered) => {
    return cadminApi.companiesGet(location.params.companySlug).then(({company}) => {
      return done({redirect: paths.cadminDashboardView(company.slug, company.companyDashboardId)});
    });
  }, [EmployeeRoles.FINANCE, EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD]));

  router.use('/cadmin/:companySlug/slack-settings', makeHandler({
    page: Pages.CADMIN_SLACK_SETTINGS,
    loadAx: PageCadminSlackSettingsAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/settings/approvals', makeHandler({
    page: Pages.CADMIN_SETTTINGS_APPROVALS,
    loadAx: PageCadminPageApprovalsDuck.Ax.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/ntee-codes', makeHandler({
    page: Pages.CADMIN_NTEE_CODES,
    loadAx: PageCadminNteeCodesDuck.Ax.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/nonprofits', makeHandler({
    page: Pages.CADMIN_NONPROFITS,
    loadAx: PageCadminNonprofitsDuck.Ax.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/employees', makeHandler({
    page: Pages.CADMIN_EMPLOYEES,
    loadAx: PageCadminEmployeesAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/employees/upload', makeHandler({
    page: Pages.CADMIN_EMPLOYEES_UPLOAD,
    loadAx: PageCadminEmployeesUploadDuck.Ax.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/employees/:employeeId', makeHandler({
    page: Pages.CADMIN_EMPLOYEE,
    loadAx: PageCadminEmployeeDuck.Ax.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/match-settings', makeHandler({
    page: Pages.CADMIN_MATCH_SETTINGS,
    loadAx: PageCadminSettingsAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/matches', makeHandler({
    page: Pages.CADMIN_MATCHES,
    loadAx: PageCadminMatchesAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/offline-donations', makeHandler({
    page: Pages.CADMIN_OFFLINE_DONATIONS,
    loadAx: PageCadminOffDonsAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/match-inquiries', makeHandler({
    page: Pages.CADMIN_MATCH_INQUIRIES,
    loadAx: PageCadminMatchInquiriesAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/wallet', makeHandler({
    page: Pages.CADMIN_WALLET,
    loadAx: PageCadminWalletAx.load,
    requireCadmin: [EmployeeRoles.FINANCE],
  }));

  router.use('/cadmin/:companySlug/budgets', makeHandler({
    page: Pages.CADMIN_BUDGETS,
    loadAx: PageCadminBudgetsDuck.Ax.load,
    requireCadmin: [EmployeeRoles.FINANCE],
  }));

  router.use('/cadmin/:companySlug/cards', makeHandler({
    page: Pages.CADMIN_CARDS,
    loadAx: CadminCardsDuck.Ax.loadPage,
    requireCadmin: [EmployeeRoles.CHAMPION],
  }));

  router.use('/cadmin/:companySlug/stats', requireDateRange(requireCadmin((done, location, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageCadminStatsDuck.Ax.load(location));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.CADMIN_STATS}))
      .catch((error) => done({error}));
  })));

  router.use('/cadmin/:companySlug/analytics', (done, location) => {
    const {query, path} = location;
    const redirect = `${path}/impact${utils.buildQueryString(query)}`;
    return done({redirect});
  });
  router.use('/cadmin/:companySlug/analytics/:presetKey', makeHandler({
    page: Pages.CADMIN_STATS2,
    loadAx: PageCadminAnalyticsDuck.Ax.loadPage,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/vol-tracking', requireCadmin((done, {params, query}, context, preRendered) => {
    if (preRendered) return;
    const fetchProm = store.dispatch(PageCadminVolTrackingAx.load(params.companySlug, query));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.CADMIN_VOL_TRACKING}))
      .catch((error) => done({error}));
  }, [EmployeeRoles.GROUP_LEAD]));

  router.use('/cadmin/:companySlug/vol-analytics', requireDateRange(requireCadmin((done, {params, query}, context, preRendered) => {
    if (preRendered) return;
    if (!['employee', 'volEvent'].includes(query.by)) {
      return done({redirect: paths.cadminVolAnalytics(params.companySlug, {...query, by: 'employee'})});
    }
    const fetchProm = store.dispatch(PageCadminVolAnalyticsAx.load(params.companySlug, query));
    const waitProm = __IS_SERVER__ ? fetchProm : Promise.resolve();
    waitProm
      .then(() => done({page: Pages.CADMIN_VOL_ANALYTICS}))
      .catch((error) => done({error}));
  })));

  router.use('/cadmin/:companySlug/dollars-for-doers', makeHandler({
    page: Pages.CADMIN_VOL_DFD,
    loadAx: PageCadminVolDfdAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/vol-events', makeHandler({
    page: Pages.CADMIN_VOL_EVENTS,
    loadAx: PageCadminVolEventsAx.load,
    requireCadmin: [EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/vol-events/new', makeHandler({
    page: Pages.CADMIN_NEW_VOL_EVENT,
    loadAx: PageCadminNewVolEventAx.load,
    requireCadmin: [EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/vol-events/:volEventId/edit', makeHandler({
    page: Pages.CADMIN_EDIT_VOL_EVENT,
    loadAx: PageCadminEditVolEventAx.load,
    requireCadmin: [EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/vol-events/:volEventId', makeHandler({
    page: Pages.CADMIN_VOL_EVENTS_VIEW,
    loadAx: PageCadminVolEventsDuck.Ax.load,
    requireCadmin: [EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/transactions2', makeHandler({
    page: Pages.CADMIN_TRANSACTIONS2,
    loadAx: PageCadminTransactions2Ax.load,
    requireCadmin: [EmployeeRoles.FINANCE],
  }));

  router.use('/cadmin/:companySlug/purchases/:purchaseId', makeHandler({
    page: Pages.CADMIN_PURCHASE,
    loadAx: PageCadminPurchaseAx.load,
    requireCadmin: [EmployeeRoles.FINANCE],
  }));

  router.use('/cadmin/:companySlug/payroll', makeHandler({
    page: Pages.CADMIN_PAYROLL,
    loadAx: PageCadminPayrollAx.load,
    requireCadmin: [EmployeeRoles.FINANCE],
  }));

  router.use('/cadmin/:companySlug/dashboards/:companyDashboardId', makeHandler({
    page: Pages.CADMIN_DASHBOARD,
    loadAx: PageCadminDashboardViewAx.load,
    requireCadmin: [EmployeeRoles.FINANCE, EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/dashboards/:companyDashboardId/edit', makeHandler({
    page: Pages.CADMIN_DASHBOARD_EDIT,
    loadAx: PageCadminDashboardEditAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/dashboards/:companyDashboardId/edit', makeHandler({
    page: Pages.CADMIN_DASHBOARD_EDIT,
    loadAx: PageCadminDashboardEditAx.load,
    requireCadmin: [EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/groups', makeHandler({
    page: Pages.CADMIN_GROUPS,
    loadAx: PageCadminGroupsAx.load,
    requireCadmin: [EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/groups/settings', makeHandler({
    page: Pages.CADMIN_GROUPS_SETTINGS,
    loadAx: PageCadminGroupsSettingsDuck.Ax.load,
    requireCadmin: [EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/groups/members', makeHandler({
    page: Pages.CADMIN_GROUP_EMPLOYEES,
    loadAx: PageCadminGroupEmployeesDuck.Ax.load,
    requireCadmin: [EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/junk-drawer', makeHandler({
    page: Pages.CADMIN_JUNK_DRAWER,
    loadAx: PageCadminJunkDrawerDuck.Ax.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/groups/new', makeHandler({
    page: Pages.CADMIN_GROUPS_NEW,
    loadAx: PageCadminGroupsNewAx.load,
    requireCadmin: [EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/groups/:groupId/edit', makeHandler({
    page: Pages.CADMIN_GROUPS_EDIT,
    loadAx: PageCadminGroupsEditAx.load,
    requireCadmin: [EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/groups/:groupId', makeHandler({
    page: Pages.CADMIN_GROUPS_VIEW,
    loadAx: PageCadminGroupsViewDuck.Ax.load,
    requireCadmin: [EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/brackets', makeHandler({
    page: Pages.CADMIN_BRACKETS,
    loadAx: PageCadminBracketsAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/brackets/new', makeHandler({
    page: Pages.CADMIN_BRACKETS_NEW,
    loadAx: PageCadminBracketsNewAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/brackets/:bracketId/edit', makeHandler({
    page: Pages.CADMIN_BRACKETS_EDIT,
    loadAx: PageCadminBracketsEditAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/brackets/:bracketId/dashboard', makeHandler({
    page: Pages.CADMIN_BRACKETS_DASHBOARD,
    loadAx: PageCadminBracketsDashboardAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/campaigns', makeHandler({
    page: Pages.CADMIN_CAMPAIGNS,
    loadAx: PageCadminCampaignsAx.load,
    requireCadmin: [EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/campaigns/new', makeHandler({
    page: Pages.CADMIN_NEW_CAMPAIGN,
    loadAx: PageCadminNewCampaignAx.load,
    requireCadmin: [EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/campaigns/templates', makeHandler({
    page: Pages.CADMIN_CAMPAIGNS_TEMPLATES,
    loadAx: PageCadminCampaignsTemplatesDuck.Ax.load,
    requireCadmin: [EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/custom-attributes', makeHandler({
    page: Pages.CADMIN_CATTRS,
    loadAx: PageCadminCattrsDuck.Ax.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/drive-donations', makeHandler({
    page: Pages.CADMIN_DRIVE_DONATIONS,
    loadAx: PageCadminDriveDonsDuck.Ax.load,
    requireCadmin: [EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/campaigns/:campaignId/edit', makeHandler({
    page: Pages.CADMIN_EDIT_CAMPAIGN,
    loadAx: PageCadminEditCampaignAx.load,
    requireCadmin: [EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/campaigns/:campaignId', makeHandler({
    page: Pages.CADMIN_CAMPAIGNS_VIEW,
    loadAx: PageCadminCampaignsViewDuck.Ax.load,
    requireCadmin: [EmployeeRoles.CHAMPION, EmployeeRoles.GROUP_LEAD],
  }));

  router.use('/cadmin/:companySlug/gifts', makeHandler({
    page: Pages.CADMIN_GIFTS,
    loadAx: PageCadminGiftsAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/gifts/new', makeHandler({
    page: Pages.CADMIN_GIFTS_NEW,
    loadAx: PageCadminGiftsNewDuck.Ax.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/grants', makeHandler({
    page: Pages.CADMIN_GRANTS,
    loadAx: PageCadminGrantsAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/grants/new', makeHandler({
    page: Pages.CADMIN_GRANTS_CREATE,
    loadAx: PageCadminGrantsNewDuck.Ax.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/billing-notifications', makeHandler({
    page: Pages.CADMIN_CHARGE_ERRORS,
    loadAx: CadminChargeErrorsDuck.Ax.loadPageIndex,
    requireCadmin: [EmployeeRoles.FINANCE],
  }));

  router.use('/cadmin/:companySlug/charge-errors/:cceId', makeHandler({
    page: Pages.CADMIN_CHARGE_ERROR,
    loadAx: CadminChargeErrorsDuck.Ax.loadPageIndex,
    requireCadmin: [EmployeeRoles.FINANCE],
  }));

  router.use('/cadmin/:companySlug/sso', makeHandler({
    page: Pages.CADMIN_SSO,
    loadAx: PageCadminSsoAx.load,
    requireCadmin: [],
  }));

  router.use('/cadmin/:companySlug/subscription', makeHandler({
    page: Pages.CADMIN_SUBSCRIPTION,
    loadAx: PageCadminSubscriptionAx.load,
    requireCadmin: [],
  }));

  /*
   *  Backstage Routes
   */

  router.use('/backstage',                      makeBsHandler({page: Pages.BS_INDEX, roles: [BackstageRoles.NONPROFIT_DATA]}));
  router.use('/backstage/pending-claims',       makeBsHandler({page: Pages.BS_PENDING_CLAIMS}));
  router.use('/backstage/failed-disbursements', makeBsHandler({page: Pages.BS_FAILED_DISBURSEMENTS}));
  router.use('/backstage/failed-charges',       makeBsHandler({page: Pages.BS_FAILED_CHARGES}));
  router.use('/backstage/users',                makeBsHandler({page: Pages.BS_USERS}));
  router.use('/backstage/users/:id',            makeBsHandler({page: Pages.BS_USER}));
  router.use('/backstage/balances',             makeBsHandler({page: Pages.BS_BALANCES}));
  router.use('/backstage/balances/transfer',    makeBsHandler({page: Pages.BS_BALANCES_TRANSFER}));
  router.use('/backstage/balances/:id',         makeBsHandler({page: Pages.BS_BALANCE}));
  router.use('/backstage/collections',          makeBsHandler({page: Pages.BS_COLLECTIONS}));
  router.use('/backstage/companies',            makeBsHandler({page: Pages.BS_COMPANIES}));
  router.use('/backstage/companies/:id',        makeBsHandler({page: Pages.BS_COMPANY}));
  router.use('/backstage/cards',                makeBsHandler({page: Pages.BS_CARDS}));
  router.use('/backstage/dashboard/overview',   makeBsHandler({page: Pages.BS_DASHBOARD_OVERVIEW}));
  router.use('/backstage/feature-flags',        makeBsHandler({page: Pages.BS_FFS}));
  router.use('/backstage/pricing',              makeBsHandler({page: Pages.BS_PRICING}));
  router.use('/backstage/config',               makeBsHandler({page: Pages.BS_CONFIG}));
  router.use('/backstage/ntee-codes',           makeBsHandler({page: Pages.BS_NTEE_CODES}));
  router.use('/backstage/nonprofits',           makeBsHandler({page: Pages.BS_NONPROFITS, roles: [BackstageRoles.NONPROFIT_DATA]}));
  router.use('/backstage/nonprofits/:id',       makeBsHandler({page: Pages.BS_NONPROFIT, roles: [BackstageRoles.NONPROFIT_DATA]}));
  router.use('/backstage/disbursements',        makeBsHandler({page: Pages.BS_DISBURSEMENTS}));
  router.use('/backstage/disbursements/:id',    makeBsHandler({page: Pages.BS_DISBURSEMENT}));
  router.use('/backstage/nonprofit-requests',   makeBsHandler({page: Pages.BS_NONPROFIT_REQUESTS, roles: [BackstageRoles.NONPROFIT_DATA]}));

  return router;
};

export default createRouter;
